import useButtonTranslations from './button.translations';
import useCancelTranslations from './cancel.translations';
import useManageTranslations from './manage.translations';
import useQuoteSummaryTranslations from './quote-summary.translations';
import useSetupTranslations from './setup.translations';
import useUpdateTranslations from './update.translations';

export {
  useButtonTranslations,
  useCancelTranslations,
  useManageTranslations,
  useQuoteSummaryTranslations,
  useSetupTranslations,
  useUpdateTranslations,
};